import { useEffect, useState } from 'react';

/*
Fetch url, if it get blocked,
should the request get error(adblock) or be redirected(u-blocker)
*/
export const useAdBlockDetect = (url: string | undefined) => {
  const [isDetected, setDetected] = useState(false);

  const onError = () => {
    setDetected(true);
  };

  useEffect(() => {
    if (url) {
      fetch(url, { mode: 'no-cors' })
        .then((response) => {
          if (response.status === 0 || response.redirected) {
            onError();
          }
          return false;
        })
        .catch(() => {
          onError();
        });
    }
  }, [url]);

  return isDetected;
};
